/**
 * Created by Damian on 2017-10-30.
 */
import { observable, toJS, computed } from 'mobx';
import _ from 'lodash';

// use  bf_config;

class GeneralSettings
{
  url = 'settings';
  @observable settings = {

  };

  @computed get getSettings(){
    return this.settings;
  }



  loadGeneralSettings(){
    $.ajax({
      // cache: false,
      headers: {
        'x-client-id': bf_config.clientID
      },
      url:  bf_config.api + this.url,
      dataType: "json",
      method : "get",
      success: (data)=>
      {
        this.settings = _.clone(data);
      },
      error:(data)=>
      {

      }
    });
  }


}

let GSettings = new GeneralSettings();
GSettings.loadGeneralSettings();
export default GSettings;